import { SUPPORT_TICKET_STATUS_I18N_KEYS } from './supportTicketStatus';

/**
 * Expand params for stored system-comment i18n (navbar locale via t()).
 * @param {(key: string, params?: object) => string} t
 * @param {Record<string, unknown>} params
 */
export function expandSystemI18nParams(t, params) {
  if (!params || typeof params !== 'object') {
    return {};
  }
  const out = { ...params };

  if (out.status != null && String(out.status).trim() !== '') {
    const rawStatus = String(out.status).trim();
    const statusKey = SUPPORT_TICKET_STATUS_I18N_KEYS[rawStatus];
    if (statusKey) {
      const tr = t(statusKey);
      if (tr && tr !== statusKey) {
        out.status = tr;
      }
    }
  }

  if (Object.prototype.hasOwnProperty.call(out, 'assignee_name')) {
    const raw = out.assignee_name;
    const name = raw == null ? '' : String(raw).trim();
    if (name !== '') {
      const role = out.assignee_clause_role;
      if (role === 'assigned') {
        out.assignee_clause = t('pending_notifications.service_task.task_table_assignee_clause_assigned', { name });
      } else if (role === 'last') {
        out.assignee_clause = t('pending_notifications.service_task.task_table_assignee_clause_last', { name });
      } else {
        out.assignee_clause = t('pending_notifications.service_task.task_table_assignee_clause_user', { name });
      }
    } else {
      out.assignee_clause = '';
    }
    delete out.assignee_name;
    delete out.assignee_clause_role;
  }

  if (out.machine_state != null && String(out.machine_state).trim() !== '') {
    const slug = String(out.machine_state).trim();
    const k = `pending_notifications.machine_states.${slug}`;
    const tr = t(k);
    out.state = tr !== k ? tr : slug;
    delete out.machine_state;
  }

  return out;
}

/**
 * @param {string} rawDescription
 * @param {(key: string, params?: object) => string} t
 * @returns {{ type: 'i18n', text: string } | { type: 'legacy', text: string }}
 */
export function resolveSystemI18nComment(rawDescription, t) {
  const raw = String(rawDescription ?? '').trim();
  if (!raw.startsWith('{')) {
    return { type: 'legacy', text: raw };
  }
  try {
    const j = JSON.parse(raw);
    const block = j?._systemI18n;
    if (block && typeof block.key === 'string' && block.key) {
      const params = block.params && typeof block.params === 'object' ? block.params : {};
      const expanded = expandSystemI18nParams(t, params);
      return { type: 'i18n', text: t(block.key, expanded) };
    }
  } catch (_) {
    /* fall through */
  }
  return { type: 'legacy', text: raw };
}
